import * as Schema from "effect/Schema";

import { PrimaryConnectionTarget, RelayConnectionTarget, type ConnectionTarget } from "./model.ts";

export interface ConnectionCatalogEntry {
  readonly target: ConnectionTarget;
}

export class PrimaryConnectionRegistration extends Schema.TaggedClass<PrimaryConnectionRegistration>()(
  "PrimaryConnectionRegistration",
  {
    target: PrimaryConnectionTarget,
  },
) {}

export class RelayConnectionRegistration extends Schema.TaggedClass<RelayConnectionRegistration>()(
  "RelayConnectionRegistration",
  {
    target: RelayConnectionTarget,
  },
) {}

export const ConnectionRegistration = RelayConnectionRegistration;
export type ConnectionRegistration = typeof ConnectionRegistration.Type;

export const PlatformConnectionRegistration = PrimaryConnectionRegistration;
export type PlatformConnectionRegistration = typeof PlatformConnectionRegistration.Type;

export function connectionRegistrationCatalogEntry(
  registration: ConnectionRegistration | PrimaryConnectionRegistration,
): ConnectionCatalogEntry {
  return { target: registration.target };
}
